module.exports = __webpack_public_path__ + "img/99.5de54ee9.jpg";